export default function GetDomainRoot(domainString) {
  let currentDomain = domainString.toString().toLocaleLowerCase();
  currentDomain = currentDomain.replaceAll("https://", "");
  currentDomain = currentDomain.replaceAll("http://", "");
  currentDomain = currentDomain.replaceAll("www.", "");
  if (currentDomain.includes("/")) currentDomain = currentDomain.split("/")[0];
  return currentDomain;
}
